// @flow

import { location } from 'window';
import url from 'url';

import Q from 'q';
import _ from 'lodash';
import $ from 'rgs-jquery';
import ko from 'rgs-knockout';
import Cookies from 'js-cookie';

import config from 'config';
import { default as browserDetector } from 'browser-type-detector';

import {
	ContextBar,
	Content,
	ContentCookieWarning,
	COOKIE_NAME,
	ContentButtonScrollToTop,
	ContentPwaIosGuideBar,
} from 'context-bar';

const parseJson = (data: () => string): {isEmpMode?: boolean} => {
	try {
		const result = data();

		if (!result) {
			return _.stubObject();
		}

		return JSON.parse(result);
	} catch (e) {
		if (e instanceof SyntaxError) {
			e.userFriendlyMessages = [
				'Ошибка при разборе файла конфигурации',
			];
		}

		throw e;
	}
};

const resolveContextConfig = () => {
	const cfg = parseJson(() =>
		$('#mode-context').html()
	);

	return _.defaults(cfg, {
		isEmpMode: false,
	});
};

const contextBarInstance = new ContextBar();

module.exports = contextBarInstance;

$(function bindMainContextBar () {
	const model = contextBarInstance;
	const defaultViewSelector = '#rgs-main-context-bar';
	const view = $(defaultViewSelector)[0];

	if (view) {
		ko.applyBindings(model, view);
	} else {
		console.info(
			'Default context bar view '
				+ defaultViewSelector
				+ ' was not found in DOM. Context bar will not appear.'
		);
	}

	const defaultContentTemplaetId = 'rgs-main-context-bar-default-content';
	const defaultContentTemplate = $('#' + defaultContentTemplaetId)[0];
	let defaultContent;
	if (defaultContentTemplate) {
		defaultContent = new (Content)({
			name: 'default',
			template: {
				name: defaultContentTemplaetId,
			},
		});
	} else {
		defaultContent = new (Content)({
			name: 'default',
		});
	}

	const buttonScrollToTopInstance = new ContentButtonScrollToTop();

	model.register(defaultContent);

	const configReady = config.cms.pageUrls.get()
		.then(pageUrls => {
			return { cms: { pageUrls } };
		});

	Q.all([resolveContextConfig(), configReady])
		.spread((contextConfig, config) => {
			const isMobileApp = contextConfig.isEmpMode;
			const isIOS = browserDetector.isIOS();
			const isStandalonePwa = browserDetector.isStandalonePwa();

			// 1. Cookie warning
			const contentCookieWarningInstance = new (ContentCookieWarning)({
				visible: () => !Cookies.get(COOKIE_NAME)
					&& !isMobileApp
					&& !isStandalonePwa,
				config: config,
			});
			model.addRow(contentCookieWarningInstance, { removable: true });

			// 2. PWA IOS Guide
			const myDomainHost = url.parse(config.cms.pageUrls.mr.base.https).host;
			const currentDomain = location.host;
			const isCurrentDomainMy = [myDomainHost, 'localhost:3002'].includes(currentDomain);

			const pwaIosGuideBar = new ContentPwaIosGuideBar({
				visible: () => isIOS
					&& !isStandalonePwa
					&& !isMobileApp
					&& isCurrentDomainMy
					&& !ContentPwaIosGuideBar.isDismissedByUser(),
			});
			model.addRow(pwaIosGuideBar, { removable: true });
		});

	model.addRow(buttonScrollToTopInstance);

	// markup for usability analysis
	$(defaultViewSelector + ' a').each(function () {
		const $btn = $(this);
		if ($btn.hasClass('visible-xs')) {
			$btn.addClass('adv-analytics-navigation-mobile-floating-menu-button');
		}
		if ($btn.hasClass('hidden-xs')) {
			$btn.addClass('adv-analytics-navigation-desktop-floating-menu-button');
		}
	});
});

